export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "app/js/app.worker.5585752da49a15630ed2.1767958467248.worker.js");
}
